import { createMultiNavigation } from '@meterup/react-router-extensions';

const regionNames = ['drawer', 'dialog'] as const;
export type RegionName = 'root' | (typeof regionNames)[number];

export const Nav = createMultiNavigation(...regionNames);
